module.exports = require("/agent/_work/1/s/node_modules/@ms/items-view/lib-esm/private/models/items/PageHelpers.js");